export const isPyAnduY = process.env.LOCALE === 'es-UY' || process.env.LOCALE === 'es-PY' 
